import React, { useState } from "react";
import axios from "axios";
import DropdownComp from "../../dropdown/dropdown";
import { useTranslation } from "react-i18next";

const JiraIntegrationPopupListInstances = props => {
  const [selectedInstance, setSelectedInstance] = useState(props.instances[0]);
  const [error, setError] = useState("");
  const { t } = useTranslation()

  const changeInstance = (event, item) => {
    setSelectedInstance(item);
  };

  const connectToJira = () => {
    setError("");
    axios
      .get(`${wbConfig.baseUrl}/integration/performJiraOAuth`, {
        params: {
          key: selectedInstance.key,
          url: selectedInstance.url
        }
      })
      .then(response => {
        if (response.data && response.data.redirect) {
          const params = `status=no,location=no,toolbar=no,menubar=no,width=400,height=400,\
            top=${window.top.outerHeight / 2 + window.top.screenY - 200},\
            left=${window.top.outerWidth / 2 + window.top.screenX - 200}`;
          const popup = window.open(response.data.redirect, "_blank", params);
          const timer = setInterval(() => {

            try {
              const href = popup.location.href;
              console.log('href', href);
              if (href.indexOf("/user/profile/edit?do=mgInt") > 0) {
                popup.close();
                clearInterval(timer);
                props.updateParentState(selectedInstance.url);
                props.closePopup(false);
              } else if (popup.location.href.indexOf("/goal/index") > 0) {
                popup.close();
                clearInterval(timer);
                props.updateParentState(selectedInstance.url);
                props.closePopup(true);
              }
            } catch (e) {}
          }, 500);
        } else {
          setError(t("Unable to connect to servers, check back later."));
        }
      });
  };

  return (
    <div className="login-jira-dropdown-list">
      <div className="login-jira-body">
        <div className="login-jira-details">
          {`Allow ${props.orgName} to access your Jira account by selecting \
                which instance you would like to connect to (these are set up by \
                an admin).}`}
        </div>
        <label>
          {t('Jira Instance URL')}<span className="typefacetext">*</span>
        </label>
        <div className="jira-dropdown-container">
          <DropdownComp
            options={props.instances} // Replace with props later, might need to make a new object with values and names
            defaultValue={selectedInstance.value}
            onChange={changeInstance}
            wrapperClass="add-okrs-dropdown-wrapper popup-dropdown-wrapper"
            appendId="jira-integration-url"
          />
          <div
            onClick={() => props.setAddAnother(true)}
            className="add-new-instance"
          >
            + {t('Connect to new instance')}
          </div>
        </div>
      </div>
      <div className="login-jira-footer">
        <input
          type="button"
          value={t("Connect")}
          className="connect-button"
          onClick={connectToJira}
        />
        <span className="login-jira-error-msg-show">{error}</span>
      </div>
    </div>
  );
};

export default JiraIntegrationPopupListInstances;
